import styled from 'styled-components'
import { Button, Box, Tooltip } from '@mui/material'
import { LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { StepsHeader } from '../../components'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const TimeContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
`

const TimeSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > span + span {
    margin-bottom: 24px;
  }
`

const Footer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const Sleep = ({ onNext, onPrevious }) => {
  const { sleepTime, setSleepTime, awakeTime, setAwakeTime } = useOnboarding()
  const { t } = useTranslation('common')

  const disableForwardButton = !sleepTime || !awakeTime

  return (
    <Container>
      <div>
        <StepsHeader
          stepText={t('onboarding.four_steps.two')}
          description={t('onboarding.sleep.description')}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimeContainer>
            <TimeSelectionContainer>
              <span
                style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}
              >
                {t('onboarding.sleep.question')}
              </span>
              <span style={{ fontSize: 18, textAlign: 'center' }}>
                {t('onboarding.sleep.input_request')}
              </span>
              <MobileTimePicker
                label={t('onboarding.sleep.placeholder')}
                ampm={false}
                minutesStep={15}
                value={sleepTime}
                onChange={newValue => setSleepTime(newValue)}
              />
            </TimeSelectionContainer>
            <TimeSelectionContainer>
              <span
                style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}
              >
                {t('onboarding.sleep.awoke.question')}
              </span>
              <span style={{ fontSize: 18, textAlign: 'center' }}>
                {t('onboarding.sleep.awoke.input_request')}
              </span>
              <MobileTimePicker
                label={t('onboarding.sleep.awoke.placeholder')}
                ampm={false}
                minutesStep={15}
                value={awakeTime}
                onChange={newValue => setAwakeTime(newValue)}
              />
            </TimeSelectionContainer>
          </TimeContainer>
        </LocalizationProvider>
      </div>
      <Footer>
        <Button
          variant='text'
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
        >
          {t('onboarding.return')}
        </Button>
        {disableForwardButton ? (
          <Tooltip
            title='Selecione os horários para continuar'
            placement='top'
            arrow
          >
            <span>
              <Button
                variant='contained'
                disabled
              >
                {t('onboarding.advance')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={onNext}
          >
            {t('onboarding.advance')}
          </Button>
        )}
      </Footer>
    </Container>
  )
}

export default Sleep
